import $ from "jquery";

$(function() {
    $(".donate-amount-button").on("click", function (){
        $(".js-donation-amount").val($(this).data("value"));
        $(".js-donation-amount-text").text($(this).data("value"));
    });

    $(".donate-amount-button").on("focus", function (){
        $(".donate-amount-button").removeClass("donate-amount-button--active");
        $(this).addClass("donate-amount-button--active");
    });

    $(".js-custom-value-input").on("keyup", function (){
         $(".js-donation-amount").val($(this).val());
         $(".js-donation-amount-text").text($(this).val());
    });

    $(".js-custom-value-input").on("change", function (){
         $(".js-donation-amount").val($(this).val());
         $(".js-donation-amount-text").text($(this).val());
    });

    $(".js-open-custom-amount").on("click", function (){
        $(".js-donate-set-value").hide();
        $(".js-enter-custom-value").show();
        $(".js-custom-value-input").attr("required", "true").val($(".js-donation-amount").val());
        $(".js-open-custom-amount").hide();//.addClass("visually-hidden");
        $(".js-close-custom-amount").show();//.removeClass("visually-hidden");

    });

    $(".js-close-custom-amount").on("click", function (){
        $(".js-donate-set-value").show();
        $(".js-enter-custom-value").hide();
        $(".js-custom-value-input").attr("required", "false");
        $(".js-open-custom-amount").show();//.removeClass("visually-hidden");
        $(".js-close-custom-amount").hide();//.addClass("visually-hidden");

        // reset
        $(".donate-amount-button").removeClass("donate-amount-button--active");
        $(".donate-amount-button[data-value='10']").addClass("donate-amount-button--active");
        $(".js-donation-amount").val(10);
        $(".js-donation-amount-text").text("10");
    });

});
